import React from 'react'

import stepIconDisabled from '../../../assets/icon/step-icon-disabled.png'
import stepIconActive from '../../../assets/icon/step-icon-active.png'
import stepIconPassed from '../../../assets/icon/step-icon-passed.png'

const Progress = ({ step, tabs, tabClassName = '' }) => {
  const tabsProgressContent = tabs.map((tab, index) => {
    const currentStepIndex = index + 1
    let stepStatusImage
    let statusText
    if (currentStepIndex === step) {
      stepStatusImage = stepIconActive
      statusText = 'Active'
    } else if (currentStepIndex < step) {
      stepStatusImage = stepIconPassed
      statusText = 'Completed'
    } else {
      stepStatusImage = stepIconDisabled
      statusText = 'Pending'
    }

    return (
      <div
        key={`tab-${tab.step}`}
        className={`w-1/5 justify-center items-center flex ${tabClassName}`}
      >
        <div
          className={`border-[1px] border-solid w-[calc(50%-16px)]`}
          style={{
            borderColor: index === 0 ? 'transparent' : step > index ? '#f67443' : '#FFCA84',
          }}
        ></div>
        <img src={stepStatusImage} alt={`Step ${currentStepIndex} ${tab.label}: ${statusText}`} />
        <div
          className={`border-[1px] border-solid w-[calc(50%-16px)]`}
          style={{
            borderColor:
              index === tabs.length - 1
                ? 'transparent'
                : step > currentStepIndex
                  ? '#f67443'
                  : '#FFCA84',
          }}
        ></div>
      </div>
    )
  })

  const tabsLabelsContent = tabs.map((tab, index) => {
    const currentStepIndex = index + 1
    return (
      <div
        key={`tab-label-${index}`}
        className={`text-center w-1/5 ${tabClassName}`}
        aria-current={currentStepIndex === step ? 'step' : undefined}
      >
        <div
          className="font-semibold"
          style={{ color: step >= currentStepIndex ? '#f67443' : '#f79009' }}
        >
          {tab.label}
        </div>
      </div>
    )
  })

  return (
    <nav aria-label="Registration Progress" className="bg-[#FEEBDD] rounded-lg mt-8 p-8">
      <div className="flex justify-center items-center">{tabsProgressContent}</div>
      <div className="flex justify-center items-center mt-[20px]">{tabsLabelsContent}</div>
    </nav>
  )
}

export default Progress
